import React from 'react';
import { Text } from '@fiverr-private/typography';

interface LabelTextProps {
    children: React.ReactNode;
}

export const LabelText = ({ children }: LabelTextProps) => (
    <Text color="bodyPrimary" fontWeight="semibold">
        {children}
    </Text>
);
